import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFacebook, faTwitterSquare } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

library.add(faFacebook,faTwitterSquare, faPlus)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.directive('visible', (el, bind) => {
    el.style.visibility=(bind.value) ? 'visible' : 'hidden';
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
